module.exports = "/_next/static/pages/partners/58405356089fcc0eff3e759c43e065f8.png";